/**
 * La mappa delle aziende (27/10/2026): la console NON legge le raccolte, passa sempre dalle funzioni del server, che
 * contano gli account con le regole dei posti e leggono l'ultima attività da Firebase Auth (dal browser non si può).
 * Il link condiviso usa la porta pubblica, col codice del link come unica credenziale.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import {
  CALLABLE_MAPPA_AZIENDE,
  type DurataCondivisione,
  type RichiestaCondivisione,
  type RispostaCondivisione,
  type RispostaMappaConsole,
  type RispostaMappaPubblica,
} from '@shared/admin/mappaAziende';

export async function leggiMappaAziende(): Promise<RispostaMappaConsole> {
  const chiama = httpsCallable<Record<string, never>, RispostaMappaConsole>(functions, CALLABLE_MAPPA_AZIENDE.console);
  return (await chiama({})).data;
}

export async function creaLinkMappa(destinatario: string, giorni: DurataCondivisione): Promise<RispostaCondivisione> {
  const chiama = httpsCallable<RichiestaCondivisione, RispostaCondivisione>(functions, CALLABLE_MAPPA_AZIENDE.condivisione);
  return (await chiama({ azione: 'crea', destinatario, giorni })).data;
}

export async function ritiraLinkMappa(codice: string): Promise<RispostaCondivisione> {
  const chiama = httpsCallable<RichiestaCondivisione, RispostaCondivisione>(functions, CALLABLE_MAPPA_AZIENDE.condivisione);
  return (await chiama({ azione: 'ritira', codice })).data;
}

export async function leggiMappaCondivisa(codice: string): Promise<RispostaMappaPubblica> {
  const chiama = httpsCallable<{ codice: string }, RispostaMappaPubblica>(functions, CALLABLE_MAPPA_AZIENDE.pubblica);
  return (await chiama({ codice })).data;
}

/** Il messaggio di un errore delle funzioni, per mostrarlo a chi guarda. */
export function motivoErrore(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
